$(document).ready(function() {
  /* Newsletter */
  var clicked = false;
  $(".form-info").on("click", function() {
    $(".newsletter-checkbox").prop("checked", !clicked);
    clicked = !clicked;
    $(this).toggleClass("active");
  });
  
  /* Swatch */
  $('.swatch :radio').change(function() {
    if($("#button-cart").hasClass("disabled") ) {
      $("#button-cart").html('Sold Out');
    } else {
      $("#button-cart").html("Add to cart");
    }
  });
  
  /* Banner Scroll */
  $(".scroll-btn").on("click", function() {
    if (this.hash !== "") {
      event.preventDefault();
      var hash = this.hash;
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
        window.location.hash = hash;
      });
    } 
  });
    
  /* Footer Toggle Mobile */  
  $(document).ready(function(){
    $(".toggle-content").hide(); 
    $(".toggle-title").click(function(){
      var thisBlock = $(this).parent().index('.footer-toggle');
      $(".footer-toggle").find(".active").not($(this)).removeClass("active");
      $(this).toggleClass("active").next().slideToggle();
      $(this).parent().toggleClass("activeToggle").siblings()
      .removeClass("activeToggle").children(".toggle-content").hide();
      return false;
    });
  });

  /* Mobile Filter */
  $(".filter-mobile a").click(function(){
    $(".collection-template .collection-inner .collection-sidebar").slideToggle();
    $(this).toggleClass('active');
  });
  
  /* stockists Toggle*/
  function stockists_mobile(){
    $(".mobile-visiable .store-box-content").hide(); 
    $(".stockists-section .store-list .store-row.mobile-visiable .store-box:first-child .store-box-title").addClass("active");
    $(".stockists-section .store-list .store-row.mobile-visiable .store-box:first-child .store-box-content").show();
    
    $(".mobile-visiable .store-box-title").click(function(){
      var thisBlock = $(this).parent().index('.store-box.mobile-visiable');
      $(".store-box.mobile-visiable").find(".active").not($(this)).removeClass("active");
      $(this).toggleClass("active").next().slideToggle();
      $(this).parent().toggleClass("activeToggle").siblings()
      .removeClass("activeToggle").children(".mobile-visiable .store-box-content").hide();
      return false;
    });
  }
  
  stockists_mobile();
  
});
